import { Wrapper } from './styles';

const Title = ({ children, ...props }) => (
    <Wrapper {...props}>
        {children}
    </Wrapper>
);

export default Title;
